import {all, takeLatest} from 'redux-saga/effects';
import {backupTypes} from '..';
import {mergeSaga} from './merge';
import {restoreSaga} from './restore';

export function* backupSagas() {
   yield all([
      takeLatest(backupTypes.MERGE.SAGA, mergeSaga),
      takeLatest(backupTypes.RESTORE.SAGA, restoreSaga),
   ]);
}
